import React from 'react';
import { useSelector } from 'react-redux';
import HeaderDropdown from '../../Components/Header/HeaderDropdown/HeaderDropdown';
import ProjectPickerItem from './ProjectPickerItem';
import { useProjects } from '../../../../hooks/useProjects';
import { selectAuthenticationContext } from '../../../../selectors';

const ProjectPicker = () => {
	const { alternativeProjects, activeProject } = useProjects();
	const { defaultSite, defaultSiteName } = useSelector(
		selectAuthenticationContext,
	);

	const Menu = alternativeProjects.map(project => (
		<ProjectPickerItem
			key={`${project.name}-${project.hubRegion}`}
			project={project}
		/>
	));

	return (
		<HeaderDropdown
			cy="project-picker"
			text={activeProject?.name ?? defaultSiteName ?? defaultSite ?? ''}
			anchorOrigin="center"
			list={Menu}
		/>
	);
};

export default ProjectPicker;
